function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{clip-path:url(#SVGID_2_);fill:#E6213C;}\r\n\t.st1{fill:#E6213C;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_1_",
  x: 44,
  y: 42,
  width: 279.8,
  height: 271
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M219.8,42c-8.4,0-16.5,0.8-24.3,2.2c7.1,3.2,13.2,7.4,18.4,12.6c2-0.1,3.9-0.2,5.9-0.2 c24.5,0,47.4,7.2,64.5,20.4c15.9,12.3,24.7,28.3,24.7,45c0,13.7-5.9,26.9-17,38.2l-3.4,3.4l-0.7,4.7l-5.9,39.5l-29.3-20.1l-5-3.4 l-6,1.1c-7.1,1.3-14.5,2-21.9,2c-5.9,0-11.7-0.4-17.4-1.3c-0.6,0.1-1.2,0.2-1.8,0.3l-5.6,5.1c6.5,3.5,13.1,7,19.3,10.4 c1.8,0.1,3.7,0.1,5.5,0.1c8.5,0,16.7-0.8,24.6-2.3l40,27.5c1.1,0.8,2.4,1.2,3.7,1.2c0.9,0,1.8-0.2,2.6-0.5c2.1-0.9,3.5-2.8,3.9-5 l7.9-52.4c13.3-13.5,21.2-30.3,21.2-48.5C323.6,77.8,277.1,42,219.8,42L219.8,42z M219.8,42"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M239.9,224.6c-8.4-5.8-37.8-21.5-50.3-28.2l-0.3-0.1c-0.6-0.3-1.3-0.5-1.9-0.5c-0.9,0-1.8,0.3-2.5,0.9 c-6.6,5.2-13.8,8.6-21.4,10.3c-1.3,0.3-2.5,1.3-2.9,2.6l-7.8,20.5l-7.8-20.5c-0.5-1.3-1.6-2.3-2.9-2.6 c-7.6-1.7-14.8-5.2-21.4-10.3c-0.7-0.6-1.6-0.9-2.5-0.9c-0.7,0-1.3,0.2-1.9,0.5c-12.4,6.6-42.2,22.7-50.6,28.3 c-14.2,9.6-20.4,44.2-21.5,51.1c-0.1,0.7,0,1.4,0.2,2c0.5,1.4,13.5,35.1,108.5,35.1c94.9,0,108-33.7,108.5-35.1 c0.2-0.7,0.3-1.3,0.2-2C258.4,257.1,252.3,233.1,239.9,224.6L239.9,224.6z M239.9,224.6"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M73.8,163.7H87c5,0,9-4,9-9v-38.1c0-3.3-1.8-6.2-4.5-7.8c2.9-31.2,15-52.8,61.2-52.8 c26.6,0,43.1,6.8,52.2,21.4c5.3,8.5,7.8,19.5,9,31.4c-2.6,1.6-4.4,4.4-4.4,7.7v38.1c0,4.3,3,7.9,7,8.8c-5.8,3.8-17.8,7.7-42.8,7.7 c-2,0-4.1,0-6.3-0.1c-1.3-2.5-3.9-4.1-6.8-4.1h-11c-4.2,0-7.7,3.4-7.7,7.7c0,4.2,3.4,7.7,7.7,7.7h11c2.6,0,4.8-1.3,6.2-3.2 c2.3,0.1,4.6,0.1,6.8,0.1c28.1,0,45.9-4.8,53.2-14.3c0.3-0.4,0.6-0.8,0.8-1.2h4.1c5,0,9-4,9-9v-38.1c0-5-4-9-9-9h-5 c-1.4-14.4-4.5-26.6-10.8-36.9c-11.4-18.5-32.1-27.5-63.1-27.5c-31,0-51.7,9-63.1,27.5c-6.4,10.3-9.4,22.5-10.8,36.9h-5 c-5,0-9,4-9,9v38.1C64.8,159.6,68.8,163.7,73.8,163.7L73.8,163.7z M73.8,163.7"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M100.8,163.3c12.3,27.3,38.8,39.1,51.9,39.1c8.6,0,23-5.1,35.4-16.4c-4.5,0.3-9.3,0.5-14.5,0.5 c-1.2,0-2.5,0-3.8,0c-2.6,2-5.8,3.1-9.2,3.1h-11c-8.3,0-15-6.7-15-15c0-8.3,6.7-15,15-15h11c4,0,7.7,1.5,10.4,4.2 c0.9,0,1.8,0,2.7,0c14.2,0,23.5-1.3,29.6-2.9c-0.8-1.9-1.2-4-1.2-6.3v-38.1c0-4,1.5-7.8,4-10.7c-1.4-10.6-3.8-18.6-7.5-24.6 c-7.6-12.3-22.2-18-45.9-18c-19.7,0-33.3,4.1-41.6,12.5c-6.4,6.5-10.2,15.8-11.9,29.9c2.6,2.9,4.1,6.8,4.1,10.8v38.1 C103.3,157.8,102.4,160.8,100.8,163.3L100.8,163.3z M100.8,163.3"
});

function SvgServcomm01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 350 350",
    style: {
      enableBackground: "new 0 0 350 350"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _ref4, _ref5), _ref6, _ref7));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServcomm01);
export default __webpack_public_path__ + "static/media/Serv comm-01.6ed902bc.svg";
export { ForwardRef as ReactComponent };